import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { subscriptionChargeLabel } from '../../../utils/subscriptionChargeLabel';

const SubscriptionResultPanel = ({ result, onClose }) => {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 flex gap-3">
        <Icon name="CalendarCheck" size={22} className="text-primary flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">Assinatura criada</p>
          <p className="text-xs text-muted-foreground">
            {result?.message ||
              'Sua assinatura foi registrada. A licença será liberada após a confirmação do pagamento.'}
          </p>
          {result?.next_payment_date && (
            <p className="text-xs text-muted-foreground">
              {subscriptionChargeLabel(result, { isCreateResult: true })}:{' '}
              {new Date(result.next_payment_date).toLocaleDateString('pt-BR')}
            </p>
          )}
        </div>
      </div>
      <Button fullWidth onClick={onClose}>
        Voltar para a loja
      </Button>
    </div>
  );
};

export default SubscriptionResultPanel;
